export default __webpack_public_path__ + "static/media/tooltip-info.0debf5a0.svg";